var _g, _mask, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "organize-yourself-folder",
    width: 315,
    height: 265,
    viewBox: "0 0 315 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1519_27213",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.022 8.21322C191.983 8.62395 187.287 10.9273 183.878 14.66L167.387 32.7173H25C11.1929 32.7173 0 43.9102 0 57.7173V239.711C0 253.518 11.1929 264.711 25 264.711H289.781C303.588 264.711 314.781 253.518 314.781 239.711V57.7173C314.781 57.6987 314.781 57.6801 314.781 57.6614V20.3099C314.781 8.62341 304.804 -0.573517 293.156 0.376049L197.022 8.21322Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.022 8.21322C191.983 8.62395 187.287 10.9273 183.878 14.66L167.387 32.7173H25C11.1929 32.7173 0 43.9102 0 57.7173V239.711C0 253.518 11.1929 264.711 25 264.711H289.781C303.588 264.711 314.781 253.518 314.781 239.711V57.7173C314.781 57.6987 314.781 57.6801 314.781 57.6614V20.3099C314.781 8.62341 304.804 -0.573517 293.156 0.376049L197.022 8.21322Z",
    fill: "url(#paint0_linear_1519_27213)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.878 14.66L183.14 13.9856V13.9856L183.878 14.66ZM197.022 8.21322L197.103 9.20991L197.022 8.21322ZM167.387 32.7173V33.7173H167.828L168.126 33.3916L167.387 32.7173ZM293.156 0.376049L293.075 -0.620644L293.156 0.376049ZM184.617 15.3343C187.855 11.7883 192.316 9.60011 197.103 9.20991L196.94 7.21652C191.65 7.6478 186.719 10.0663 183.14 13.9856L184.617 15.3343ZM168.126 33.3916L184.617 15.3343L183.14 13.9856L166.649 32.0429L168.126 33.3916ZM25 33.7173H167.387V31.7173H25V33.7173ZM1 57.7173C1 44.4625 11.7452 33.7173 25 33.7173V31.7173C10.6406 31.7173 -1 43.3579 -1 57.7173H1ZM1 239.711V57.7173H-1V239.711H1ZM25 263.711C11.7452 263.711 1 252.965 1 239.711H-1C-1 254.07 10.6406 265.711 25 265.711V263.711ZM289.781 263.711H25V265.711H289.781V263.711ZM313.781 239.711C313.781 252.965 303.036 263.711 289.781 263.711V265.711C304.141 265.711 315.781 254.07 315.781 239.711H313.781ZM313.781 57.7173V239.711H315.781V57.7173H313.781ZM313.781 57.6614C313.781 57.6717 313.781 57.6818 313.781 57.691C313.781 57.7004 313.781 57.7089 313.781 57.7173H315.781C315.781 57.707 315.781 57.6969 315.781 57.6877C315.781 57.6783 315.781 57.6698 315.781 57.6614H313.781ZM313.781 20.3099V57.6614H315.781V20.3099H313.781ZM293.237 1.37274C304.303 0.470655 313.781 9.20774 313.781 20.3099H315.781C315.781 8.03909 305.305 -1.61769 293.075 -0.620644L293.237 1.37274ZM197.103 9.20991L293.237 1.37274L293.075 -0.620644L196.94 7.21652L197.103 9.20991Z",
    fill: "url(#paint1_linear_1519_27213)",
    mask: "url(#path-1-inside-1_1519_27213)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_1519_27213",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.886 27.1392C206.346 27.6817 201.283 30.5085 197.914 34.9397L187.466 48.6832H45.9141C32.1069 48.6832 20.9141 59.8761 20.9141 73.6832V216.794C20.9141 230.601 32.1069 241.794 45.914 241.794H268.86C282.667 241.794 293.86 230.601 293.86 216.794V73.6832C293.86 73.0118 293.833 72.3466 293.781 71.6885C293.833 71.1023 293.86 70.5088 293.86 69.9091V41.1659C293.86 29.3499 283.67 20.1095 271.91 21.2612L211.886 27.1392Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.886 27.1392C206.346 27.6817 201.283 30.5085 197.914 34.9397L187.466 48.6832H45.9141C32.1069 48.6832 20.9141 59.8761 20.9141 73.6832V216.794C20.9141 230.601 32.1069 241.794 45.914 241.794H268.86C282.667 241.794 293.86 230.601 293.86 216.794V73.6832C293.86 73.0118 293.833 72.3466 293.781 71.6885C293.833 71.1023 293.86 70.5088 293.86 69.9091V41.1659C293.86 29.3499 283.67 20.1095 271.91 21.2612L211.886 27.1392Z",
    fill: "url(#paint2_linear_1519_27213)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.914 34.9397L198.71 35.5449L197.914 34.9397ZM211.886 27.1392L211.789 26.144L211.886 27.1392ZM187.466 48.6832V49.6832H187.962L188.262 49.2884L187.466 48.6832ZM293.781 71.6885L292.785 71.6007L292.778 71.6839L292.785 71.7672L293.781 71.6885ZM271.91 21.2612L272.008 22.2564L271.91 21.2612ZM198.71 35.5449C201.911 31.3352 206.721 28.6498 211.984 28.1344L211.789 26.144C205.972 26.7136 200.656 29.6817 197.118 34.3344L198.71 35.5449ZM188.262 49.2884L198.71 35.5449L197.118 34.3344L186.67 48.078L188.262 49.2884ZM45.9141 49.6832H187.466V47.6832H45.9141V49.6832ZM21.9141 73.6832C21.9141 60.4284 32.6592 49.6832 45.9141 49.6832V47.6832C31.5547 47.6832 19.9141 59.3238 19.9141 73.6832H21.9141ZM21.9141 216.794V73.6832H19.9141V216.794H21.9141ZM45.914 240.794C32.6592 240.794 21.9141 230.049 21.9141 216.794H19.9141C19.9141 231.153 31.5546 242.794 45.914 242.794V240.794ZM268.86 240.794H45.914V242.794H268.86V240.794ZM292.86 216.794C292.86 230.049 282.115 240.794 268.86 240.794V242.794C283.219 242.794 294.86 231.153 294.86 216.794H292.86ZM292.86 73.6832V216.794H294.86V73.6832H292.86ZM292.785 71.7672C292.834 72.3992 292.86 73.0381 292.86 73.6832H294.86C294.86 72.9855 294.832 72.294 294.778 71.6098L292.785 71.7672ZM292.86 69.9091C292.86 70.4794 292.834 71.0436 292.785 71.6007L294.778 71.7764C294.832 71.1609 294.86 70.5381 294.86 69.9091H292.86ZM292.86 41.1659V69.9091H294.86V41.1659H292.86ZM272.008 22.2564C283.18 21.1624 292.86 29.9407 292.86 41.1659H294.86C294.86 28.7591 284.161 19.0567 271.813 20.2659L272.008 22.2564ZM211.984 28.1344L272.008 22.2564L271.813 20.2659L211.789 26.144L211.984 28.1344Z",
    fill: "url(#paint3_linear_1519_27213)",
    mask: "url(#path-3-inside-2_1519_27213)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1519_27213",
    x1: 312.943,
    y1: 57.8194,
    x2: 288.736,
    y2: 135.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#160337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1519_27213",
    x1: 310.227,
    y1: 57.8194,
    x2: 297.906,
    y2: 82.3303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C6EFF",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AA5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1519_27213",
    x1: 284.987,
    y1: 19.4113,
    x2: 224.426,
    y2: 296.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#160337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1519_27213",
    x1: 271.882,
    y1: 19.4113,
    x2: 239.092,
    y2: 112.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C6EFF",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AA5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderImage);
export default __webpack_public_path__ + "static/media/FolderImage.56cff372ea24a14354cc8d3c4b37a0db.svg";
export { ForwardRef as ReactComponent };